/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListAccessRolesResponse,
} from '../models/index';
import {
    ListAccessRolesResponseFromJSON,
    ListAccessRolesResponseToJSON,
} from '../models/index';

export interface ListAccessRolesRequest {
    limit?: number;
    orderBy?: Array<string>;
    page?: number;
    perPage?: number;
    where?: { [key: string]: object; };
    _with?: Array<string>;
}

/**
 * 
 */
export class AccessRoleApi extends runtime.BaseAPI {

    /**
     * List all available roles
     * List Access Roles
     */
    async listAccessRolesRaw(requestParameters: ListAccessRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccessRolesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.access-role.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/access-roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAccessRolesResponseFromJSON(jsonValue));
    }

    /**
     * List all available roles
     * List Access Roles
     */
    async listAccessRoles(requestParameters: ListAccessRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccessRolesResponse> {
        const response = await this.listAccessRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
